
import { defineComponent, computed, ref } from 'vue';

import AskusFilter from '@/components/askus/AskusFilter.vue';
import AskusListContent from '@/components/askus/AskusListContent.vue';
import VueLoading from '@/components/general/Loading.vue';
import Paginator from 'primevue/paginator';

import { askusStore } from '@/store/askus-store';

import { IAskusQuestion } from '@/models/askus.model';

export default defineComponent({
  //Prevents warning caused by the keep alive functionality.
  // Warnings included -> use of externious Props...etc
  inheritAttrs: false,
  name: 'AskusList',
  props: {
    askusid: {
      type: Number,
      required: true,
    },
  },
  components: {
    Paginator,
    AskusFilter,
    AskusListContent,
    VueLoading,
  },
  emits: ['openQuestion'],
  setup(props, context) {
    const isLoading = computed(() => {
      return askusStore.getState().isLoadingContent;
    });
    const questions = computed(() => {
      return askusStore.getState().question;
    });
    const pager = computed(() => {
      return askusStore.getState().pager;
    });

    function onPageChange(event: any) {
      askusStore.updateToPage(event.page + 1);
      askusStore.fetchQuestions();
    }

    function openQuestion(question: IAskusQuestion, questionid: number) {
      context.emit('openQuestion', question, questionid);
    }

    return {
      questions,
      pager,
      isLoading,
      onPageChange,
      openQuestion,
    };
  },
});
